<template>
    <div v-if="show">
        <div class="flex items-center mr-8">
            <h2 class="font-bold text-gray-800 leading-tight" style="white-space: nowrap;">
                <span v-if="$page.props.active_trial">Trial Number:</span>
                <span v-else>Your Number:</span>
            </h2>
            <p class="text-sm ml-2" style="white-space: nowrap;">{{ phoneNumber }}</p>

            <div
                v-if="!this.$page.props.active_trial"
                class="ml-4"
                :class="{
                    'text-green-500': status === 'Verified',
                    'text-yellow-500': status === 'Pending Review',
                    'text-red-500': status === 'Action Required'
                }"
            >
                <span v-if="status === 'Verified'" class="font-bold">
                    <font-awesome-icon :icon="['fass', 'circle-check']" /> {{status}}
                </span>
                <span v-else-if="status === 'Pending Review'" class="font-bold whitespace-nowrap">
                    {{status}}
                </span>
                <Link href="/verified/start" class="font-bold w-full" v-else>
                    <div style="white-space: nowrap;">
                        <font-awesome-icon :icon="['fass', 'circle-exclamation']" /> Action Required: Submit Application
                    </div>
                </Link>
            </div>

            <!-- Daily limit text - shows inline on larger screens (1536px+) -->
            <div v-if="$page.props.a2p_send_limited" class="hidden 2xl:block ml-4 text-sm text-gray-600" style="white-space: nowrap;">
                Limited to {{ $page.props.a2p_daily_limit }} credits per day
            </div>
        </div>

        <!-- Daily limit text - shows below on smaller screens (under 1536px) -->
        <div v-if="$page.props.a2p_send_limited" class="2xl:hidden text-sm text-gray-600 mt-1">
            Limited to {{ $page.props.a2p_daily_limit }} credits per day
        </div>
    </div>
    
</template>


<script>

import {mapWritableState, mapActions, mapState} from 'pinia';
import { useGlobalStore } from '@/Stores/global';

export default {
    name: "PhoneNumberAndStatus",
    components: {  },
    mounted() {
        
    },
    data() {
        return {
            
        };
    },
    computed: {
        ...mapState(useGlobalStore, ['isPhoneNumberActive']),
        phoneNumber() {
            if (!this.$page) {
                return '';
            }
            
            let org = this.$page.props.auth.user.organization;

            if (!org.primary_number) {
                return '';
            }

            //return org.primary_number;

            //actually, phone number will need to be formatted into 1 (555) 555-5555 format
            return org.primary_number.replace(/(\d)(\d{3})(\d{3})(\d{4})/, '$1 ($2) $3-$4');
        },
        show() {
            if (!this.$page) {
                return false;
            }
            if (!this.phoneNumber) {
                return false;
            }
            return this.$page.props.active_trial || this.$page.props.own_number_purchased;
        },
        status() {
            if (!this.$page) {
                return '';
            }
            if (this.$page.props.active_trial) {
                return 'Trial';
            }

            if (this.$page.props.auth.user.organization.a2p_verified && this.isPhoneNumberActive) {
                return 'Verified';
            }
            if (this.$page.props.auth.user.organization.a2p_submitted) {
                return 'Pending Review';
            }
            return 'Action Required';
        }
    },
    methods: {
        
    }
};
</script>